import React, {useState} from 'react';
import {Form, Input, Button, message} from 'antd';
import {db} from '../../config/firebase';
import {doc, updateDoc} from 'firebase/firestore';

interface PasswordForm {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
}

const ChangePassword: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm(); // 将 form 实例移到这里

    const onFinish = async (values: PasswordForm) => {
        if (values.newPassword !== values.confirmPassword) {
            message.error('Passwords do not match');
            return;
        }

        try {
            setLoading(true);

            // 从 localStorage 获取当前用户信息
            const userStr = localStorage.getItem('adminUser');
            if (!userStr) {
                message.error('User not found');
                return;
            }

            const user = JSON.parse(userStr);

            // 更新数据库中的密码
            const userRef = doc(db, 'admins', user.id);
            await updateDoc(userRef, {
                password: values.newPassword,
                updatedAt: new Date().getTime()
            });

            message.success('Password updated successfully');
            // 重置表单
            form.resetFields();

        } catch (error) {
            console.error('Change password error:', error);
            message.error('Failed to update password');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-md mx-auto mt-8">
            <Form
                form={form} // 将 form 实例传递给 Form 组件
                name="changePassword"
                onFinish={onFinish}
                layout="vertical"
            >
                <Form.Item
                    label="Current Password"
                    name="currentPassword"
                    rules={[
                        {required: true, message: 'Please input your current password!'},
                        {min: 6, message: 'Password must be at least 6 characters!'}
                    ]}
                >
                    <Input.Password/>
                </Form.Item>

                <Form.Item
                    label="New Password"
                    name="newPassword"
                    rules={[
                        {required: true, message: 'Please input your new password!'},
                        {min: 6, message: 'Password must be at least 6 characters!'},
                        ({getFieldValue}) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('currentPassword') !== value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject('New password cannot be the same as current password!');
                            },
                        }),
                    ]}
                >
                    <Input.Password/>
                </Form.Item>

                <Form.Item
                    label="Confirm Password"
                    name="confirmPassword"
                    dependencies={['newPassword']}
                    rules={[
                        {required: true, message: 'Please confirm your password!'},
                        {min: 6, message: 'Password must be at least 6 characters!'},
                        ({getFieldValue}) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('newPassword') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject('The two passwords do not match!');
                            },
                        }),
                    ]}
                >
                    <Input.Password/>
                </Form.Item>

                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        className="w-full"
                    >
                        Update Password
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default ChangePassword;
